/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface ProjectUpdateDto
 */
export interface ProjectUpdateDto {
    /**
     *
     * @type {string}
     * @memberof ProjectUpdateDto
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof ProjectUpdateDto
     */
    name?: string | null;
}

export function ProjectUpdateDtoFromJSON(json: any): ProjectUpdateDto {
    return ProjectUpdateDtoFromJSONTyped(json, false);
}

export function ProjectUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ProjectUpdateDtoToJSON(value?: ProjectUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowId': value.workflowId,
        'name': value.name,
    };
}

